import { bindFormElements } from './includes/sitewide/bindFormElements.js';
import { initializeCalendarFields } from './includes/sitewide/calendar.js';
import { fetchResults } from './includes/sitewide/fetchResults.js';
import { preloadFormFields } from './includes/sitewide/preloadFormFields.js';
import { elements } from './includes/sitewide/elements.js';

/**
 * Sitewide, resource library, and corporate documents search.
 */
export const initializeSearchSitewide = () => {
    if (!elements.searchForm) return;
    const { allChoices } = preloadFormFields();
    bindFormElements(allChoices);
    initializeCalendarFields();
    fetchResults();
};
